// @ts-nocheck
import React from "react";
import { Box, withStyles, createStyles } from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import { surveyStyles, aboutUsStyle } from "./surveyStyles";
import QuestionCard from "./layout/QuestionCard.web";
import StepFooter from "./layout/StepFooter.web";
import FirmQuestions from "./layout/FirmQuestions.web";
import OptionToggle from "./layout/OptionToggle.web";
import { MagicLinkSelectField } from "./layout/FormFields.web";
import { magicLinkFormOverrides } from "./layout/formStyleOverrides";
import { isExistingClient } from "./surveyOptions";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const AccountingSchema = Yup.object().shape({
  isHelpNeededinAccounting: Yup.string().required("This field is required"),
  noOFBankAccount: Yup.string(),
  isManageInvoice: Yup.string().required("This field is required"),
  noOFInvoice: Yup.string(),
  isBalanceSheetAccurate: Yup.string(),
  noOfmonthForBalanceSheet: Yup.string(),
});

const numberOptions = (max, lastLabel) =>
  Array.from({ length: max + 1 }, (_, value) => ({
    value,
    label: value === max && lastLabel ? lastLabel : String(value),
  }));

const BANK_ACCOUNT_OPTIONS = numberOptions(10);
const INVOICE_OPTIONS = numberOptions(50, "50+");
const MONTHS_BEHIND_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, "12"].map(
  (value) => ({ value, label: String(value) })
);

export const AccountingComponent = (props) => {
  const { classes, gotoBackStep, gotoNextStep, setValueByDynamicName } = props;
  const hasAccountingSystem = props.currentAccountingSystem !== "None";
  const getTitle = () => {
    if (hasAccountingSystem && isExistingClient(props.step1Selection)) {
      return "Provide any update about your accounting.";
    }
    return "Tell us about your accounting";
  };
  const helpQuestion = hasAccountingSystem
    ? "Do you need any help with managing your ongoing accounting?"
    : "Do you need any assistance with setting up accounting for your business?";

  return (
    <Fade in={true} timeout={3000}>
      <Formik
        initialValues={{
          isHelpNeededinAccounting: props.isHelpNeededinAccounting || "false",
          noOFBankAccount: props.noOFBankAccount,
          isManageInvoice: props.isManageInvoice || "false",
          noOFInvoice: props.noOFInvoice,
          isBalanceSheetAccurate: props.isBalanceSheetAccurate,
          noOfmonthForBalanceSheet: props.noOfmonthForBalanceSheet,
        }}
        validationSchema={AccountingSchema}
        validateOnMount
        onSubmit={() => {
          gotoNextStep();
        }}
      >
        {(formikProps) => {
          const { values, setFieldValue, isValid } = formikProps;
          const setValue = (name, value) => {
            setValueByDynamicName(name, value);
            setFieldValue(name, value);
          };
          const goBack = () => {
            setValue("isHelpNeededinAccounting", "");
            setValue("noOFBankAccount", "");
            setValue("isManageInvoice", "");
            setValue("noOFInvoice", "");
            setValue("isBalanceSheetAccurate", "");
            setValue("noOfmonthForBalanceSheet", "1");
            gotoBackStep();
          };
          const setYesNo = (name) => (checked) =>
            setValue(name, checked ? "true" : "false");
          const setBalanceSheetAccurate = (checked) => {
            setValue("isBalanceSheetAccurate", checked);
            if (checked) {
              setValue("noOfmonthForBalanceSheet", 0);
            }
          };
          const handleSelect = (event) =>
            setValue(event.target.name, event.target.value);
          return (
            <Form autoComplete="off" noValidate>
              <QuestionCard title={getTitle()}>
                <OptionToggle
                  inputId="isHelpNeededinAccounting"
                  label={helpQuestion}
                  checked={values.isHelpNeededinAccounting === "true"}
                  onChange={setYesNo("isHelpNeededinAccounting")}
                />
                <OptionToggle
                  inputId="isManageInvoice"
                  label="Do you want us to manage sending/receiving invoices?"
                  checked={values.isManageInvoice === "true"}
                  onChange={setYesNo("isManageInvoice")}
                />
                {hasAccountingSystem && (
                  <OptionToggle
                    inputId="isBalanceSheetAccurate"
                    label="Are your balance sheet and profit statement completely accurate within the last month?"
                    checked={!!values.isBalanceSheetAccurate}
                    onChange={setBalanceSheetAccurate}
                  />
                )}
                <Box className={classes.accountingFields}>
                  <MagicLinkSelectField
                    label="How many bank and/or credit card account do you have for your business?"
                    name="noOFBankAccount"
                    id="noOFBankAccount"
                    value={values.noOFBankAccount}
                    options={BANK_ACCOUNT_OPTIONS}
                    onChange={handleSelect}
                  />
                  <MagicLinkSelectField
                    label="Generally, how many invoices do you send/receive monthly?"
                    name="noOFInvoice"
                    id="noOFInvoice"
                    value={values.noOFInvoice}
                    options={INVOICE_OPTIONS}
                    onChange={handleSelect}
                  />
                  {hasAccountingSystem && !values.isBalanceSheetAccurate && (
                    <MagicLinkSelectField
                      label="If not, how many months are you behind on your accounting?"
                      name="noOfmonthForBalanceSheet"
                      id="noOfmonthForBalanceSheet"
                      value={values.noOfmonthForBalanceSheet}
                      options={MONTHS_BEHIND_OPTIONS}
                      onChange={handleSelect}
                    />
                  )}
                </Box>
              </QuestionCard>
              <FirmQuestions
                screen="accounting_details"
                taxPayerType={props.taxPayerType}
                questions={props.firmQuestions}
                answers={props.firmAnswers}
                onChange={props.setFirmAnswer}
              />
              <StepFooter
                onBack={goBack}
                backId="backButton"
                nextType="submit"
                nextId="nextButton"
                nextDisabled={!isValid}
              />
            </Form>
          );
        }}
      </Formik>
    </Fade>
  );
};
export default withStyles((theme) =>
  createStyles({
    ...surveyStyles(theme),
    ...aboutUsStyle(theme),
    ...magicLinkFormOverrides(theme),
    accountingFields: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: "20px 32px",
      padding: "20px 0",
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "minmax(0, 1fr)",
        gap: 16,
      },
    },
  })
)(AccountingComponent);
